import { render, staticRenderFns } from "./DissertationPage.vue?vue&type=template&id=64f93989&scoped=true"
import script from "./DissertationPage.vue?vue&type=script&lang=js"
export * from "./DissertationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f93989",
  null
  
)

export default component.exports